export const RANDOM_COLORS: string[] = [
  '#2C3E50', // Midnight Blue
  '#3498DB', // Ocean Blue
  '#74B9FF', // Sky Blue
  '#1ABC9C', // Teal
  '#55EFC4', // Aquamarine
  '#2ECC71', // Emerald Green
  '#7BED9F', // Lime Green
  '#5DA271', // Jade

  '#8E44AD', // Deep Purple
  '#6C5CE7', // Royal Violet
  '#A29BFE', // Lavender

  '#FF9F43', // Peach
  '#FBC531', // Golden Yellow
  '#EAB543', // Mustard Yellow

  '#D63031', // Red
  '#FF6B81', // Coral Pink
  '#D4A0A7', // Rose Brown
]

export const getRandomColor = (): string => {
  return RANDOM_COLORS[Math.floor(Math.random() * RANDOM_COLORS.length)]
}
